import { RegionType } from 'flow/types/region-lookup/UserRegion';

export const regions = {
    SWEDEN: 'sweden1',
    UK: 'uk1',
    DEFAULT: 'sweden1',
} as const;

export const sourceData = {
    GOOGLE: 'google',
    MICROSOFT: 'microsoft',
    OIDC: 'oidc',
} as const;

export const timeZoneLocationMap: Record<string, RegionType> = {
    'Europe/Stockholm': regions.SWEDEN,
    'Europe/London': regions.UK,
};

export const REGION_MISMATCH_LOGOUT = 'region-mismatch';
